import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-small-service-card',
  templateUrl: './small-service-card.component.html',
  styleUrls: ['./small-service-card.component.scss']
})
export class SmallServiceCardComponent implements OnInit {
  @Input() service;

  constructor() {}

  ngOnInit() {}
}
